import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import areaCalculation from '../../../../algorithms/geometry/AreaCalculation';

export const SplitFieldStatus = ({
  LangFile,
  selectedField,
  polygons,
  splitFieldInputs,
  renderFieldInput,
  setSplitFieldInput,
  fieldASize,
  fieldBSize,
}) => {
  // Calculate the original field size
  const selectedFieldSize = selectedField.size.toFixed(2);

  fieldASize = fieldASize ? fieldASize : '0.00';
  fieldBSize = fieldBSize ? fieldBSize : '0.00';

  // If polygons are drawn recalculate sizes
  if (polygons[0] && polygons[1]) {
    fieldASize = areaCalculation({ coords: polygons[0].path }).size.toFixed(2);
    fieldBSize = areaCalculation({ coords: polygons[1].path }).size.toFixed(2);
  }

  return (
    <Box>
      <Divider
        style={{
          marginTop: 0,
          marginBottom: '8px',
          backgroundColor: '#ddd',
        }}
      />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography variant="body2" style={{ marginBottom: '20px' }}>
          {LangFile.PolygonDrawing.currentFieldArea}:
        </Typography>
        <Typography variant="body2" style={{ fontWeight: 'bold', color: '#2c3e50' }}>
          {selectedFieldSize} ha
        </Typography>
      </Box>

      {renderFieldInput(
        LangFile.SplitFieldInputDialog.fieldAName,
        splitFieldInputs.fieldAName,
        'fieldAName',
        fieldASize,
        setSplitFieldInput,
        false
      )}
      {renderFieldInput(
        LangFile.SplitFieldInputDialog.fieldANumber,
        splitFieldInputs.fieldANumber,
        'fieldANumber',
        null,
        setSplitFieldInput,
        true
      )}
      {renderFieldInput(
        LangFile.SplitFieldInputDialog.fieldBName,
        splitFieldInputs.fieldBName,
        'fieldBName',
        fieldBSize,
        setSplitFieldInput,
        false
      )}
      {renderFieldInput(
        LangFile.SplitFieldInputDialog.fieldBNumber,
        splitFieldInputs.fieldBNumber,
        'fieldBNumber',
        null,
        setSplitFieldInput,
        true
      )}
    </Box>
  );
};
